import { Subscription } from '../types/entities'

export const mockSubscriptions: Subscription[] = [
  {
    id: 's1',
    clientId: 'c1',
    planName: 'Premium',
    monthlyPrice: 4500,
    status: 'active',
    startDate: '2023-03-15',
    renewalDate: '2025-03-15',
    projectIds: ['p1', 'p2'],
  },
  {
    id: 's2',
    clientId: 'c2',
    planName: 'Manutenção',
    monthlyPrice: 1800,
    status: 'active',
    startDate: '2024-07-01',
    renewalDate: '2025-07-01',
    projectIds: ['p3'],
  },
  {
    id: 's3',
    clientId: 'c3',
    planName: 'Premium',
    monthlyPrice: 5500,
    status: 'active',
    startDate: '2024-01-10',
    renewalDate: '2025-01-10',
    projectIds: ['p4'],
  },
  {
    id: 's4',
    clientId: 'c4',
    planName: 'Desenvolvimento',
    monthlyPrice: 6000,
    status: 'active',
    startDate: '2024-04-22',
    renewalDate: '2025-04-22',
    projectIds: ['p5'],
  },
  {
    id: 's5',
    clientId: 'c5',
    planName: 'Standard',
    monthlyPrice: 4800,
    status: 'active',
    startDate: '2024-09-05',
    renewalDate: '2025-09-05',
    projectIds: ['p6'],
  },
]
